import { createBrowserRouter, RouterProvider } from "react-router";

import AppProvidesr from "@/providers/providesr";
import routes from "@/routes";

const App = () => {
  const router = createBrowserRouter(routes);
  return (
    <AppProvidesr>
      <RouterProvider router={router} />
    </AppProvidesr>
  );
};

export default App;
